import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-get-started',
  templateUrl: './get-started.component.html',
  styleUrls: ['./get-started.component.css']
})
export class GetStartedComponent implements OnInit {
  mybutton;
  constructor(private title: Title,private meta: Meta,private router: Router) { }

  ngOnInit() {

    this.title.setTitle('Energy Service for Business Owners, Operators and Investors, Powered by AI');
    this.meta.updateTag({name: 'keywords', content: 'commercial energy,business energy,reverse-auction,negotiation,representation,fixed rate,variable rate,index rate,blend and extend,free bill analysis,energy contract management,energy roadmap,energy broker,energy advisor,energy consultant,experienced energy expert,business owner,retail store front,shopping center,restaurant chain,energy procurement,free analysis,energy supply,energy strategy,ways to decrease overhead,custom pricing,reverse auction,get started'});
    this.meta.updateTag({name: 'description', content: 'Honest Gorilla is your one-stop to shop for a better energy plan. Leverage our purchasing power and portfolio to your financial gain.'});
    this.meta.updateTag({name: 'author', content: 'HonestGorilla'});
    this.meta.updateTag({name: 'robots', content: 'index, follow'});

    $(window).scroll(function () {
      const scrollPos = $(window).scrollTop(),
        navH = $('nav').height();
        let mybutton = document.getElementById("myBtn1");
        if (scrollPos > 20) {
         // mybutton.style.display = "block";
        } else {
          //mybutton.style.display = "none";
        }
      $('.sections').each(function (i) {
        const offT = $(this).offset().top;
        if ((offT - scrollPos - navH) <= 0) {
          $('.active').removeClass('active')
          $('.navigate li').eq(i).addClass('active')
        }
      });
    });
    $('.navigate li').click(function () {
      $('.navigate li').removeClass('active');
      $(this).addClass('active');
    });

    setTimeout(() => {
      const letsgoScroll = document.getElementsByTagName('html');
      if (letsgoScroll[0].classList.contains('letsgo')) {
        letsgoScroll[0].classList.remove('letsgo');
      }
    }, 30);
  }
  getQuestionnaire() {
    this.router.navigateByUrl('/commercial/questionnaire');
  }
  getslide(param) {
    param.scrollIntoView({ behavior: 'smooth' });
  }

}
